/* global console */ // eslint-disable-line

//********************************************
// Implemented split of file
// For anonymous users all will be done in Vue

import Vue from 'vue';
import qs from 'qs';
import './regions';
import { initSearchTracking } from './tracking';
import store from './searchStore';
import searchCategory from './categories';
import filter from './filter';
import filterGroup from './filterGroup';
import searchDatabase from './database';
import searchSorting from './sorting';
import searchCompanyRegions from './regionsCompany';
import searchRegions from './regions';
import selectUpdate from './selectUpdate';
import selectSearchable from 'components/selectSearchable';
import searchHistory from './searchHistory';
import zipCodes from './zipCodes';
import searchAutocomplete from 'components/searchAutocomplete';
import { isMobile } from 'tools/isMobile';
import { searchFormSubmit } from './searchFormSubmit';
import serializer from 'form-serialize';
import { initGCSLinks } from './searchGcs';
import { GOOGLE_ENGINE_IDS } from './googleEngineIds';
import { createCookie } from 'tools/cookies';
import GlobalDataSearch from './globalData';

// Elements for search
import SearchResults from './searchResults';
import { pushToDataLayerResult } from './dataLayer';

// check if we are in new search mechanism
// const url = new URL(location);

// new search only for non users
const defaultValue = true;
if (defaultValue) {
    Vue.component('KobraSearch', () => import (/* webpackChunkName: "kobra" */ './kobra'));
    Vue.component('KobraFilter', () => import (/* webpackChunkName: "kobraFilter" */ './kobraFilter'));
    if (document.querySelector('[data-has-gds]') && document.querySelector('[data-has-gds]').dataset.hasGds) {
        Vue.component('GlobalDataSearch', () => import (/* webpackChunkName: "globalData" */ './globalData'));
    }
    if (window.document.getElementById('anoSearchResults')) {
        new Vue({
            store,
            el: '#anoSearchResults',
            components: {
                'ano-search-results': SearchResults,
            },
            mounted() {
                initSearchTracking();
                initGCSLinks();
                this.$store.commit('initSearchQueryParameters');
            },
        });
    }
    if (window.document.getElementById('searchResults')) {
        // Ids of macro regions which have country selection disabled
        window.vue = new Vue({
            store: store,
            el: '#searchResults',
            components: {
                'select-search-category': searchCategory,
                'select-search-database': searchDatabase,
                'select-search-sorting': searchSorting,
                'select-filter-group': filterGroup,
                'select-searchable': selectSearchable,
                'select-update': selectUpdate,
                'search-history': searchHistory,
                'search-regions': searchRegions,
                'search-company-regions': searchCompanyRegions,
                'search-zip-codes': zipCodes,
                'search-filter': filter,
                'search-autocomplete': searchAutocomplete,
                'global-data-search': GlobalDataSearch,
            },
            data: {
                statisticsForecasts: getFormCheckedById('statistics') && getFormCheckedById('forecasts'),
                isMobile: isMobile(),
                searchFilter: true,
                mainfilters: {
                    ode: getFormCheckedById('ode'),
                },
                showSearchField: true,
                allFiltersDisabled: false,
                countryFieldDisabled: false,
                regionFieldDisabled: false,
                hideRegions: false,
                removeRegions: false,
                selectedLanguage: document.getElementById('searchbar') ? document.getElementById('searchbar').getAttribute('data-selected-language') : '0',
                selectedSorting: document.getElementById('searchbar') ? document.getElementById('searchbar').getAttribute('data-selected-sorting') : null,
                showCompanyRegions: false,
                companyRegions: [],
                hasGCS: store.getters.hasGCS,
                locale: window.stGlobals.locale,
                searchQuery: document.getElementById('searchResults') ? document.getElementById('searchResults').getAttribute('data-search-query') : '',
                selectedKobraBranchGroup: null,
                selectedKobraInfoType: null,
                selectedKobraSearchType: null,
                accordionOpen: false,
            },
            watch: {
                selectedKobraBranchGroup() {
                    this.updateKobraUriFromParameters();
                },
                selectedKobraInfoType() {
                    this.updateKobraUriFromParameters();
                },
                selectedKobraSearchType() {
                    this.updateKobraUriFromParameters();
                },
            },
            methods: {
                updateGlobalDataSearch() {
                    this.$refs.globaldatasearch.updateSearchResults();
                    this.updateGlobalDataUriFromParameters();
                },
                updateKobraSearch() {
                    this.$refs.kobrasearch.updateSearchResults();
                    this.updateKobraUriFromParameters();
                },
                updateKobraUriFromParameters() {
                    const parameters = qs.parse(window.location.search.substring(1));
                    if (parameters) {
                        parameters.searchType = this.selectedKobraSearchType;
                        parameters.branchGroup = this.selectedKobraBranchGroup;
                        parameters.infoType = this.selectedKobraInfoType;
                        parameters.q = this.searchQuery;

                        history.pushState(null, null, `?${ qs.stringify(parameters) }#kobra`);
                    }
                },
                updateGlobalDataUriFromParameters() {
                    const parameters = qs.parse(window.location.search.substring(1));
                    parameters.q = this.searchQuery;

                    history.pushState(null, null, `?${ qs.stringify(parameters) }#globaldata`);
                },
                updateCompanyRegion(regions) {
                    this.companyRegions = regions;
                },
                setFilterDisabled(state) {
                    // Utility funtion to disable filters from TWIG depending on user rights
                    this.$store.commit('allFiltersDisabled', state);
                    this.allFiltersDisabled = state;

                    return this.allFiltersDisabled;
                },
                bindSetViewDisabledOnSubmit() {
                    document.getElementById('searchForm').addEventListener('submit', () => {
                        this.countryFieldDisabled = true;
                        this.regionFieldDisabled = true;
                        this.showSearchField = false;
                        this.removeRegions = true;
                        if (this.hideRegions) {
                            // FIX BECAUSE BUG – REGION WAS SUBMITTED EVEN WHEN VUEJS REMOVES THE ELEMENT
                            document.getElementById('region').outerHTML = '';
                        }
                    });
                },
                delegateClicks() {
                    const attr = 'data-delegateClickTo';
                    const attrSelector = `[${ attr }]`;
                    const delegateClickToTargets = document.querySelectorAll(attrSelector);
                    delegateClickToTargets.forEach(element => {
                        element.addEventListener('click', (event) => {
                            const clickTarget = event.target.dataset.delegateclickto;
                            const target = document.querySelector(clickTarget);
                            if (target) {
                                target.click();
                            }
                        });
                    });
                },
                getGoolgeEngineId(locale) {
                    return GOOGLE_ENGINE_IDS[locale];
                },
                initGoogleCustomSearch() {
                    window.__gcse = {
                        callback: gcseCallback,
                    };
                    function gcseCallback() {
                        const searchQuery = document.getElementById('searchResults').getAttribute('data-search-query');
                        document.querySelector('input.gsc-input[name=search]').value = typeof searchQuery !== 'undefined' ? searchQuery : '';

                        const hiddenContainer = document.querySelector('.gsc-resultsbox-invisible');
                        const child = document.querySelector('[data-gcse-no-results]');
                        if (hiddenContainer !== null) {
                            insertAfter(child, hiddenContainer);
                        }
                        function insertAfter(newNode, referenceNode) {
                            referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
                        }
                    }
                    const googleEngineId = this.getGoolgeEngineId(this.locale);
                    const gcseScriptElement = document.createElement('script');
                    gcseScriptElement.type = 'text/javascript';
                    gcseScriptElement.async = true;
                    gcseScriptElement.src = `https://cse.google.com/cse.js?cx=${ googleEngineId }`;
                    const s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(gcseScriptElement, s);
                },
                checkDebug() {
                    // check debug checkbox and add event listener
                    const checkbox = document.querySelector('input[name=showDebug]');
                    if (checkbox) {
                        checkbox.addEventListener('change', function() {
                            const hideDebugWhenChecked = this.checked ? 0 : 1;
                            createCookie('hideDebug', hideDebugWhenChecked, 1);
                            document.location.reload();
                        });
                    }
                },
            },
            mounted() {
                initSearchTracking();
                initGCSLinks();
                this.delegateClicks();
                this.bindSetViewDisabledOnSubmit();
                this.$store.commit('initSearchQueryParameters');
                const hasGCS = document.getElementById('searchResults').getAttribute('data-has-gcs');
                if (hasGCS === 'true') {
                    this.initGoogleCustomSearch();
                }
                this.checkDebug();
            },
        });

        /* eslint-disable no-inner-declarations */

        // Please move function or change to function-assignment: https://stackoverflow.com/a/26768233
        function getFormCheckedById(formId) {
            if (document.getElementById(formId)) {
                return document.getElementById(formId).checked;
            }

            return null;
        }

        function updateSparkline(currentElement) {
            if (currentElement && currentElement.dataset) {
                const sparkElement = parseInt(currentElement.dataset.sparkhighlight);
                const sparklines = document.querySelectorAll('.sparkline');

                if (sparklines.length) {
                    sparklines.forEach((sparkline, i) => {
                        ['opacity-40', 'opacity-60', 'opacity-80', 'opacity-90', 'opacity-100'].forEach(className => {
                            sparkline.classList.remove(className);
                        });
                        if (i - 3 === sparkElement || i + 3 === sparkElement) {
                            sparkline.classList.add('opacity-60');
                        } else if (i - 2 === sparkElement || i + 2 === sparkElement) {
                            sparkline.classList.add('opacity-80');
                        } else if (i - 1 === sparkElement || i + 1 === sparkElement) {
                            sparkline.classList.add('opacity-90');
                        } else if (i === sparkElement) {
                            sparkline.classList.add('opacity-100');
                        } else {
                            sparkline.classList.add('opacity-40');
                        }
                    });
                }
            }
        }

        /* eslint-enable */

        const accuracyRadioButtons = document.querySelectorAll('input[name="accuracy"]');
        if (accuracyRadioButtons.length) {
            accuracyRadioButtons.forEach(radioBtn => {
                radioBtn.addEventListener('change', () => {
                    updateSparkline(radioBtn);
                });
            });
        }
        updateSparkline(document.querySelector('input[name="accuracy"]:checked'));

        const searchForm = document.getElementById('searchForm');
        const originalFilter = serializer(searchForm);
        const searchRefreshButton = document.querySelector('[data-searchrefresh]');
        const resetButton = document.getElementById('js-reset-all-filters');
        const MINIMAL_FILTER_REFRESH_TIMEOUT = 4; // lowest possible timeout value (DOM_MIN_TIMEOUT_VALUE)
        // Reset button stuff
        if (resetButton) {
            resetButton.addEventListener('click', () => {
                if (!resetButton.classList.contains('disabled')) {
                    // reset event for vue coponents
                    const resetEvent = new CustomEvent('reset');
                    const filtersElement = document.querySelector('[data-entityfilter]');
                    filtersElement.dispatchEvent(resetEvent);

                    // reset archive input = 1 is default
                    const archive = document.getElementById('archive');
                    if (archive) {
                        archive.value = 1;
                    }

                    // reset accurace = 1 is default
                    const accuracy = document.getElementById('accuracy_1');
                    if (accuracy) {
                        accuracy.checked = true;
                    }

                    // reset interval = 0 is default
                    const interval = document.getElementById('interval');
                    if (interval) {
                        interval.value = 0;
                    }

                    const zipCodes = document.getElementById('zipCodes');
                    if (zipCodes) {
                        resetFilter(zipCodes, 'zipcodeContainer');
                    }

                    // reset revenue filter
                    const revenues = document.getElementById('revenues');
                    if (revenues) {
                        resetFilter(revenues, 'revenuesContainer');
                    }

                    // reset employees filter
                    const employees = document.getElementById('employees');
                    if (employees) {
                        resetFilter(employees, 'employeesContainer');
                    }

                    resetButton.classList.add('disabled');
                }
            });
        }

        /* eslint-disable no-inner-declarations */

        // Please move function or change to function-assignment: https://stackoverflow.com/a/26768233
        function resetFilter(element, toggleName) {
            const elementChoices = element.querySelectorAll('input[type="checkbox"]');
            if (elementChoices.length) {
                elementChoices.forEach(elementChoice => {
                    elementChoice.checked = false;
                });
                hideToggle(toggleName);
            }
        }

        // COMPANIES
        // reset ZIP/PLZ = 0 is default
        function hideToggle(name) {
            const toggle = document.querySelector(`[data-hide="${ name }"]`);
            if (toggle && toggle.classList.contains('isOpen')) {
                const toggleTarget = document.getElementById(toggle.dataset.hide);
                toggle.classList.remove('isOpen');
                if (toggleTarget.style.display !== '') {
                    toggleTarget.style.display = '';
                }
            }
        }

        /* eslint-enable */

        searchForm.addEventListener('change', () => {
            setTimeout(() => {
                const refreshButtons = document.querySelectorAll('[data-refreshbutton]');
                // Check if filters are different from default values #}
                const newFilter = serializer(searchForm);
                if (newFilter !== originalFilter) {
                    searchRefreshButton.innerText = searchRefreshButton.dataset.searchrefresh;
                    refreshButtons.forEach(refreshButton => {
                        refreshButton.classList.remove('disabled');
                    });
                    if (resetButton) {
                        resetButton.classList.remove('disabled');
                    }
                } else {
                    searchRefreshButton.innerText = '';
                    refreshButtons.forEach(refreshButton => {
                        refreshButton.classList.add('disabled');
                    });
                    if (resetButton) {
                        resetButton.classList.add('disabled');
                    }
                }
            }, MINIMAL_FILTER_REFRESH_TIMEOUT);
        });

        const searchResultItemElements = document.getElementsByName('searchResultItems');
        if (searchResultItemElements) {
            searchResultItemElements.forEach((searchResultItemElement, index) => {
                searchResultItemElement.addEventListener('click', () => {
                    pushToDataLayerResult(index);
                });
            });
        }

        const contentRefreshElements = document.querySelectorAll('[data-searchrefresh], [data-refreshbutton], #searchSubmitButton');
        contentRefreshElements.forEach(contentRefreshElement => {
            contentRefreshElement.addEventListener('click', event => {
                if (!contentRefreshElement.classList.contains('disabled')) {
                    searchFormSubmit(event);
                }
            });
            contentRefreshElement.addEventListener('keyup', event => {
                if (event.keyCode === 13 && !contentRefreshElement.classList.contains('disabled')) {
                    searchFormSubmit(event);
                }
            });
        });

        const excelButton = document.querySelector('.button--excel');
        if (excelButton) {
            excelButton.addEventListener('click', () => {
                downloadCSV({ filename: excelButton.dataset.filename });
            });
        }

        /* eslint-disable no-inner-declarations */

        // Please move function or change to function-assignment: https://stackoverflow.com/a/26768233
        function downloadCSV(args) {
            let link;
            let csv = convertArrayOfObjectsToCSV({
                data: document.querySelector('#csvData').dataset.data,
            });
            if (csv === null) {
                return;
            }

            const filename = args.filename || 'export.csv';
            csv = `\uFEFF${ csv }`;
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
            if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                link = document.createElement('a');
                if (link.download !== undefined) {
                    // feature detection, Browsers that support HTML5 download attribute
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }

        function convertArrayOfObjectsToCSV(args) {
            let result, ctr;

            const data = JSON.parse(args.data) || null;
            if (data === null || !data.length) {
                return null;
            }

            const columnDelimiter = args.columnDelimiter || ';';
            const lineDelimiter = args.lineDelimiter || '\n';

            const keys = Object.keys(data[0]);

            result = '';
            result += keys.join(columnDelimiter);
            result += lineDelimiter;
            data.forEach(item => {
                ctr = 0;
                keys.forEach(key => {
                    if (ctr > 0) {
                        result += columnDelimiter;
                    }

                    result += `"${ item[key] }"`;
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }

    }
}
